<script lang="ts">
	import { siteConfig } from '$lib/config/site';
	import { mode } from '$lib/state/global.svelte';
	
	type FooterItem = {
		title: string;
		path?: string | null;
		externalPath?: string | null;
		items?: Array<{
			title: string;
			path?: string | null;
			externalPath?: string | null;
		}>;
	};
	
	let { footer }: { footer: FooterItem[] } = $props();

	const year = new Date().getFullYear();
</script>

<footer class="border-t bg-background py-12">
	<div class="container">
		<!-- Footer Columns -->
		<div class="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
			{#each footer as column}
				{#if column.items && column.items.length > 0}
					<div class="space-y-4">
						<h3 class="text-sm font-semibold text-foreground">{column.title}</h3>
						<ul class="space-y-3">
							{#each column.items as item}
								<li>
									<a
										href={item.externalPath || (item.path ? `/${item.path}` : '#')}
										class="text-sm text-muted-foreground transition-colors hover:text-foreground"
										target={item.externalPath ? '_blank' : '_self'}
										rel={item.externalPath ? 'noopener noreferrer' : ''}
									>
										{item.title}
									</a>
								</li>
							{/each}
						</ul>
					</div>
				{/if}
			{/each}
		</div>

		<!-- Bottom Section -->
		<div class="mt-12 border-t pt-8">
			<div class="flex flex-col items-center justify-between gap-4 md:flex-row">
				<div class="flex flex-col items-center gap-4 md:flex-row md:gap-6">
					<a href="/" class="flex items-center space-x-2">
						{#if $mode === 'dark'}
							<img alt="MVMNT" src={siteConfig.darkLogo} class="w-[90px]" />
						{:else}
							<img alt="MVMNT" src={siteConfig.lightLogo} class="w-[90px]" />
						{/if}
					</a>
					<span class="text-sm text-muted-foreground">
						{siteConfig.legalName} © {year} All Rights Reserved.
					</span>
				</div>
				
				<!-- Legal Links -->
				<div class="flex flex-wrap items-center gap-4 text-sm text-muted-foreground">
					{#each footer as nav}
						{#if !nav.items || nav.items.length === 0}
							<a
								href={nav.externalPath || (nav.path ? `/${nav.path}` : '#')}
								class="transition-colors hover:text-foreground"
								target={nav.externalPath ? '_blank' : '_self'}
								rel={nav.externalPath ? 'noopener noreferrer' : ''}
							>
								{nav.title}
							</a>
						{/if}
					{/each}
				</div>
			</div>
		</div>
	</div>
</footer>
